import { getAntiForgeryToken } from "../sdk";
import {
  AccountsClient,
  accountsClient,
} from "./accountsClient/accountsClient";
import { accountsClientStub } from "./accountsClient/stub";
import {
  AnalyticsClient,
  analyticsClient,
} from "./analyticsClient/analyticsClient";
import { analyticsClientStub } from "./analyticsClient/stub";
import {
  BlobFilesClient,
  legacyBlobFilesClient,
} from "./blobFilesClient/blobFilesClient";
import { blobFilesClientStub } from "./blobFilesClient/stub";
import { CompetitionsClient } from "./competitionsClient/competitionsClient";
import { competitionsClientStub } from "./competitionsClient/stub";
import {
  DatasetsClient,
  legacyDatasetsClient,
} from "./datasetsClient/datasetsClient";
import { datasetsClientStub } from "./datasetsClient/stub";

export const defaultFetchOptions: RequestInit = {
  headers: new Headers({ "Content-Type": "application/json" }),
  credentials: "include",
};

export const getGetRequestFetchOptions = async () => {
  const antiForgeryToken = getAntiForgeryToken();
  const postFetchOptions: RequestInit = {
    headers: new Headers({
      "Content-Type": "application/json",
      __requestverificationtoken: antiForgeryToken,
      "X-XSRF-TOKEN": antiForgeryToken,
    }),
    method: "GET",
  };

  return {
    ...defaultFetchOptions,
    ...postFetchOptions,
  };
};

export const getPostRequestFetchOptions = async () => {
  const postFetchOptions: RequestInit = {
    headers: new Headers({
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": getAntiForgeryToken(),
    }),
    method: "POST",
  };

  return {
    ...defaultFetchOptions,
    ...postFetchOptions,
  };
};

export interface LegacyClients {
  accountsClient: AccountsClient;
  analyticsClient: AnalyticsClient;
  blobFilesClient: BlobFilesClient;
  competitionsClient: CompetitionsClient;
  datasetsClient: DatasetsClient;
}

export const legacyClients: LegacyClients = {
  analyticsClient,
  accountsClient,
  blobFilesClient: legacyBlobFilesClient,
  // TODO(mbooth): Migrate to Command Handler. Currently using adhocClient.
  competitionsClient: {} as any,
  datasetsClient: legacyDatasetsClient,
};

export const legacyClientsStub: LegacyClients = {
  accountsClient: accountsClientStub,
  analyticsClient: analyticsClientStub,
  blobFilesClient: blobFilesClientStub,
  competitionsClient: competitionsClientStub,
  datasetsClient: datasetsClientStub,
};
